import React, { useEffect, useState } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import { MdAddCircle } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import {
  Home,
  MapPin,
  Wifi,
  Tv,
  User,
  Building,
  Dumbbell,
  AirVent,
  Sofa,
} from "lucide-react";
import { IoCarSport } from "react-icons/io5"; // Ionicons
import { MdDirectionsBike } from "react-icons/md"; // Material Design Icons
import { CgGym } from "react-icons/cg"; // Carriè
import { FaTv } from "react-icons/fa"; // Font Awesome
import { RiFridgeFill } from "react-icons/ri"; // Remix Icons
import { GiWashingMachine } from "react-icons/gi"; // Game Icons
import CreatePg from "../../components/AdminSideComponents/CreatePg";
import EditPg from "../../components/AdminSideComponents/EditPg";
import ConfigurePg from "../../components/AdminSideComponents/ConfigurePg";
import axios from "axios";
import toast from "react-hot-toast";

const Resources = () => {
  const [loadModal, setLoadModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [currentItem, setCurrentItem] = useState({});
  const [EditLoadModal, setEditLoadModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // State to track loading

  const [totalRooms, setTotalRooms] = useState(0);
  const [totalBeds, setTotalBeds] = useState(0);
  const [totalFloors, setTotalFloors] = useState(0);
  const navigate = useNavigate();

  const items = [
    {
      name: "Number Of Buildings",
      numberOfItems: buildings?.length,
      icon: bedsLogo,
    },
    {
      name: "Number Of Floors",
      numberOfItems: totalFloors,
      icon: bedsLogo,
    },
    {
      name: "Number Of Rooms",
      numberOfItems: totalRooms,
      icon: bedsLogo,
    },
    {
      name: "Number Of Beds",
      numberOfItems: totalBeds,
      icon: bedsLogo,
    },
  ];

  useEffect(() => {
    let totalFloors = 0;
    for (let building of buildings) {
      totalFloors += building.totalFloors;
    }
    setTotalFloors(totalFloors);
  }, [buildings]);

  const deleteBuilding = (id) => {
    if (window.confirm("Are you sure , you want to delete this item ?")) {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/resources/delete_building/${id}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          toast.success(response.data.message);
          fetchAllBuildings();
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.message);
        });
    }
  };

  const fetchAllBuildings = () => {
    setIsLoading(true); // Start loading
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of fetchAllBuildings: ", response.data);
        setBuildings(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false); // End loading
      });
  };

  //Function to get total room count
  const getRoomCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_room_counts`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getRoomCounts: ", response.data);
        setTotalRooms(response.data.totalRooms);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Error in getRoomCounts: ", error);
        setIsLoading(false);
      });
  };

  //Function to get total bed count
  const getBedCounts = () => {
    setIsLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get_bed_counts`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getBedCounts: ", response.data);
        setTotalBeds(response.data.totalBeds);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Error in getBedCounts: ", error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
    getRoomCounts();
    getBedCounts();
  }, [loadModal, EditLoadModal]);

  return (
    <div className="rosourcesContainer p-6 bg-primarybgColor">
      {loadModal ? <CreatePg setLoadModal={setLoadModal} /> : ""}
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Resources
      </h1>
      <Cards items={items} />
      <div className="flex justify-between items-center my-6">
        <h1 className="text-[18px] text-primaryTextColor sm:text-[24px] font-bold">
          Building Lists
        </h1>

        <MdAddCircle
          onClick={() => {
            setLoadModal(true);
          }}
          className="text-primaryColor rounded-lg cursor-pointer"
          size={50}
        />
      </div>
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {/* Skeleton loader */}
          {isLoading ? (
            Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="bg-skeletonLoaderColor animate-pulse rounded-lg p-4 h-40"
              ></div>
            ))
          ) : buildings && buildings.length > 0 ? (
            buildings.map((eachItem, index) => (
              <div key={index} className="bg-white shadow-lg rounded-lg p-4">
                {EditLoadModal ? (
                  <EditPg
                    setEditLoadModal={setEditLoadModal}
                    currentItem={currentItem}
                  />
                ) : (
                  ""
                )}
                <h2
                  onClick={() => {
                    navigate(`/rooms_list/${eachItem._id}`);
                  }}
                  className="cursor-pointer text-xl font-semibold mb-2 text-primaryTextColor"
                >
                  {eachItem.nameBuilding}
                </h2>
                <div className="text-secondaryTextColor flex items-center space-x-2 mb-2">
                  <span>{eachItem.buildingType}</span>
                  <User size={18} /> <span>{eachItem.pgType}</span>
                </div>
                <div className="text-secondaryTextColor flex items-center space-x-2 mb-4">
                  <MapPin size={18} /> <span>{eachItem.pgAddress}</span>
                </div>
                <div id="Icons" className="flex flex-wrap gap-3 mb-4">
                  {eachItem.amenities.internet && (
                    <Wifi size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.commonLoungeArea && (
                    <Tv size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.bikeParking && (
                    <MdDirectionsBike size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.carParking && (
                    <IoCarSport size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.airConditioner && (
                    <AirVent size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.furnishedRooms && (
                    <Sofa size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.refrigerator && (
                    <RiFridgeFill size={24} className="text-gray-400" />
                  )}
                  {eachItem?.amenities?.washingMachine && (
                    <GiWashingMachine size={24} className="text-gray-400" />
                  )}
                </div>
                <div className="flex items-center justify-between gap-2">
                  <button
                    onClick={() => {
                      navigate(`/rooms_list/${eachItem._id}`);
                    }}
                    className="bg-primaryBtnColor text-white py-1 px-4 rounded-md"
                  >
                    {eachItem.totalFloors} Floors-{eachItem.totalRooms} Rooms
                  </button>
                  <div className="flex  flex-col sm:flex-row gap-2 md:space-x-2 space-x-0">
                    <button
                      onClick={() => {
                        deleteBuilding(eachItem._id);
                      }}
                      className="w-[6rem] md:w-auto bg-secondaryTextColor text-primaryTextColor py-1 px-4 rounded-md"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => {
                        setEditLoadModal(true);
                        setCurrentItem(eachItem);
                      }}
                      className="w-[6rem]   bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white py-1 px-4 rounded-md"
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-secondaryTextColor text-lg text-center col-span-full">
              No Properties are available
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Resources;
